export default "/images/0c176bae290c5854ebf30764799fac81.avif";